import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { allowedTabs } from "../constants/permissionCatalog";
import TournamentsCommentsReports from "../pages/dashboardPage/tournamentsComments/tournamentsCommentsReports/TournamentsCommentsReports";
import PreviousReports from "../pages/dashboardPage/tournamentsComments/tournamentsCommentsReports/PreviousReports";
import AllTournamentComments from "../pages/dashboardPage/tournamentsComments/allTournamentComments/AllTournamentComments";

// Tab id (permissionCatalog "tournament-comments") → its page.
const TAB_PAGES = {
  "comment-reports": TournamentsCommentsReports,
  "previous-reports": PreviousReports,
  "all-comments": AllTournamentComments,
};

const TournamentsCommentsNavigator = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const tabs = allowedTabs("tournament-comments", rolePermissions);
  const FirstTab = tabs[0] ? TAB_PAGES[tabs[0].id] : null;

  return (
    <Routes>
      {tabs.map((tab) => {
        const Page = TAB_PAGES[tab.id];
        return <Route key={tab.id} path={`/${tab.path}`} element={<Page />} />;
      })}
      {FirstTab && <Route path="*" element={<FirstTab />} />}
    </Routes>
  );
};

export default TournamentsCommentsNavigator;
